// VoK MUI base styles
import typography from "app/assets/theme/base/typography";

// VoK MUI helper functions
import pxToRem from "app/assets/theme/functions/pxToRem";

const {size} = typography;

const dialogTitle = {
    styleOverrides: {
        root: {
            padding: pxToRem(16),
            fontSize: size.xl,
        },
    },
};

export default dialogTitle;
